export const PenEditIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="path1"
        fill="currentColor"
        fillRule="evenodd"
        stroke="none"
        d="M 17.883301 5.487499 L 19.008301 6.612499 C 19.6667 7.262501 19.6667 8.320801 19.008301 8.9708 L 7.9833 19.9958 L 4.5 19.9958 L 4.5 16.512501 L 13.1667 7.8375 L 15.525 5.487499 C 16.174999 4.8375 17.233299 4.8375 17.883301 5.487499 Z M 6.1667 18.329201 L 7.3417 18.3792 L 15.525 10.1875 L 14.35 9.012501 L 6.1667 17.195801 L 6.1667 18.329201 Z"
      />
    </svg>
  )
}
